import { loadTheme, OurBrands } from '@sial/common-design'
import { getBrandIdentity } from '@src/utils/getBrandIdentity'
import getFeatureFlags from '@src/utils/getFeatureFlags'

const featureFlags = getFeatureFlags()
const brandIdentity = getBrandIdentity()

const siteTheme = loadTheme(
  OurBrands[brandIdentity],
  featureFlags.replaceLatoWithNoto
)

export const theme = siteTheme
